import React, { useEffect } from 'react'
import './ECatalog.scss'

import Header from '../../components/Header/Header'
import UnderHeader from '../../components/UnderHeader/UnderHeader'
import PageTitle from '../../components/PageTitle/PageTitle'
import Footer from '../../components/Footer/Footer'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import EcatalogContent from '../../components/EcatalogContect/EcatalogContent'

export default function ECatalog() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])
  
  return (
    <div>
      <Header page={'ecatalog'} />
      <UnderHeader className={'ecatalog'} />
      <PageTitle mainTitle={'E-CATALOG'} page={'E-CATALOG'} />
      <EcatalogContent />
      <LogoPartner />
      <Footer />
    </div>
  )
}
